module.exports = __webpack_public_path__ + "img/AR.281a2aa0.svg";